var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.0562 16C32.0562 20.2568 30.4036 24.2632 27.4031 27.2812C24.4043 30.2969 20.4124 31.9724 16.1611 31.9993C16.1506 31.9993 16.1392 32 16.1287 31.9993C16.105 32 16.0806 32 16.0562 32C11.783 32 7.76489 30.3362 4.74292 27.3137C1.72046 24.292 0.0561523 20.2737 0.0561523 16C0.0561523 11.7263 1.72046 7.70874 4.74292 4.68628C7.76489 1.66431 11.783 0 16.0562 0C16.0806 0 16.1042 0 16.1287 0.000732425C16.1399 0.000732425 16.1511 0.000732425 16.1624 0.0012207C20.4131 0.0288086 24.4048 1.70386 27.4031 4.71948C30.4036 7.73755 32.0562 11.7437 32.0562 16Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1356 6.73777C16.1617 6.73728 16.1129 6.73777 16.1356 6.73777V6.73777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8013 9.40381V16.5562C18.8013 18.0264 17.6055 19.2224 16.1355 19.2224H16.1287C15.4419 19.2024 14.7329 18.925 14.25 18.4419C13.7468 17.9382 13.4692 17.2688 13.4692 16.5562V9.40381C13.4692 7.94995 14.6763 6.7793 16.1287 6.73755H16.1355C17.6055 6.73755 18.8013 7.93384 18.8013 9.40381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.135 19.2227C16.1123 19.2227 16.1577 19.2231 16.135 19.2227V19.2227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6587 22.6025C18.6587 23.9944 17.5269 25.1262 16.135 25.1262H16.1287C14.7405 25.123 13.6118 23.9924 13.6118 22.6025C13.6118 21.2131 14.7405 20.0825 16.1287 20.0793H16.135C17.5269 20.0793 18.6587 21.2112 18.6587 22.6025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6589 22.6025C18.6589 23.9944 17.5271 25.1262 16.1353 25.1262H16.1289V20.0793H16.1353C17.5271 20.0793 18.6589 21.2112 18.6589 22.6025Z",
    fill: "#DDEBF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8015 9.40381V16.5562C18.8015 18.0264 17.6057 19.2224 16.1357 19.2224H16.1289V6.73755H16.1357C17.6057 6.73755 18.8015 7.93384 18.8015 9.40381Z",
    fill: "#DDEBF0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.0561523)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertIcon);
export default __webpack_public_path__ + "static/media/alert_icon.a5b8c4c4bd698a973aab767379463221.svg";
export { ForwardRef as ReactComponent };